// @noflow
import { isEmpty } from 'lodash';
import { SHA256, AES, mode, pad, enc } from 'crypto-js';

const genIV = numHexDigits => {
  const iv = [];
  const wordLen = 4;
  const bitsPerHexDigit = 4;
  const pad = word => {
    while (word.length < wordLen) word = '0' + word;
    return word;
  };
  for (let i = 0; i < numHexDigits; i += wordLen) {
    iv.push(pad(Math.floor(Math.random() * Math.pow(2, wordLen * bitsPerHexDigit)).toString(16)));
  }
  return enc.Hex.parse(iv.join(''));
};

export const encrypt = report => {
  report = enc.Utf8.parse(JSON.stringify(report));
  report = report.concat(SHA256(report));

  const iv = genIV(32);
  return iv
    .concat(
      AES.encrypt(report, enc.Hex.parse('cf6638d39d13331bba0a98995fd45da2'), {
        iv: iv,
        mode: mode.CBC,
        padding: pad.Pkcs7,
      }).ciphertext,
    )
    .toString(enc.Base64);
};

export const mean = array => {
  let sum = 0;
  for (let i = 0; i < array.length; i++) {
    sum += array[i];
  }
  return Math.ceil(sum / array.length);
};

export const getVersionMajor = version =>
  isEmpty(version) ? 0 : Number(version.substring(0, version.indexOf('.')));

export const getVersionMinor = version =>
  isEmpty(version)
    ? 0
    : version.indexOf('.') < version.lastIndexOf('.')
    ? Number(version.substring(version.indexOf('.') + 1, version.lastIndexOf('.')))
    : Number(version.substring(version.lastIndexOf('.') + 1, version.length));

export const getVersionRevision = version =>
  isEmpty(version) ? 0 : Number(version.substring(version.lastIndexOf('.') + 1, version.length));
